var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5556 16.4624C19.9389 17.0502 20.7778 17.8213 20.7778 18.6668C20.7778 20.508 16.7978 22.0002 11.8889 22.0002C6.98 22.0002 3 20.508 3 18.6668C3 17.8224 3.83889 17.0491 5.22222 16.4624",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4446 8.04889C17.4446 11.4856 11.8891 17.5556 11.8891 17.5556C11.8891 17.5556 6.3335 11.4856 6.3335 8.04889C6.3335 4.61334 8.82128 2 11.8891 2C14.9568 2 17.4446 4.61334 17.4446 8.04889V8.04889Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8889 8.66656C12.5026 8.66656 13.0001 8.1691 13.0001 7.55545C13.0001 6.9418 12.5026 6.44434 11.8889 6.44434C11.2753 6.44434 10.7778 6.9418 10.7778 7.55545C10.7778 8.1691 11.2753 8.66656 11.8889 8.66656Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/address-icon.a9342cc9dead45b5d29220fbe6a0a9bb.svg";
export { ForwardRef as ReactComponent };